import { Outlet } from "react-router-dom";
import styled from "styled-components";




const PageWrapper = styled.main`
 
  min-height: 100vh;
  background-color: #f7f6f1; /* opcional si quieres fondo suave */
`;

function Layout() {
  return (
    <>
     
      <PageWrapper id="contenido-principal" tabIndex={-1}>
        <Outlet />
      </PageWrapper>
      
    </>
  );
}

export default Layout;
